import { Translations } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../public/locales/de.json";
import en from "../public/locales/en.json";

export const sharedComponentsTranslations: Translations = { de, en };
